import { forIn, map, sortBy } from "lodash";
import { DirectConnectionType } from "./DirectConnectionType";
import type { IrMap } from "./IrMap";

export class DirectConnectionTypeFunctions {
    public static GetDirectConnectionTypes(): DirectConnectionType[] {
        const directConnectionTypes: DirectConnectionType[] = [];
        forIn(DirectConnectionType, (key) => {
            if (typeof key === "number") {
                directConnectionTypes.push(key as any as DirectConnectionType);
            }
        });
        return directConnectionTypes;
    }

    public static GetDirectConnectionTypeDictionary(
        $translate: angular.translate.ITranslateService,
    ): IrMap<DirectConnectionType, string> {
        return sortBy(
            map(DirectConnectionTypeFunctions.GetDirectConnectionTypes(), (dct) => ({
                key: dct,
                value: $translate.instant(`Entities.DirectConnectionType.Enum${DirectConnectionType[dct]}`),
            })),
            "value",
        );
    }
}
